import React, {useContext} from 'react';
import {FormattedMessage} from "react-intl";

import SidebarItem from "../../../SidebarItem";
import SidebarNavMenu from "../../components/SidebarNavMenu";

import {ReactComponent as ArrowIcon} from "assets/img/arrow-3.svg";

import {Authorizations, hasAuthorization} from "utils/authorizations";
import {MarketplaceRoutes} from "utils/MarketplaceRoutes";

import {SidebarContext} from "../../../../../../SidebarContext";

function MerchandisingItem(props) {
    const {currentPath, currentMemberAuthorizations} = useContext(SidebarContext);

    const hasMerchandisingAuthorization = hasAuthorization(currentMemberAuthorizations, Authorizations.MARKETPLACE_MERCHANDISING) &&
        (
            hasAuthorization(currentMemberAuthorizations, Authorizations.MARKETPLACE_PRODUCT_VIEW) || // Theses two authorizations are needed for accessing to the merchandising/products route
            hasAuthorization(currentMemberAuthorizations, Authorizations.MARKETPLACE_PRODUCT_MANAGEMENT)
        );
    const hasOrganizationManagementAuthorization = hasAuthorization(currentMemberAuthorizations, Authorizations.GLOBAL_ORGANIZATION_MANAGEMENT);
    const hasCategoryManagementAuthorization = hasAuthorization(currentMemberAuthorizations, Authorizations.MARKETPLACE_CATEGORY_MANAGEMENT);

    if (
        !hasMerchandisingAuthorization
        && !hasOrganizationManagementAuthorization
        && !hasCategoryManagementAuthorization
    ) {
        return null;
    }

    const isInMerchandisingPath = !!(
        currentPath.startsWith(MarketplaceRoutes.MERCHANDISING)
        || currentPath.startsWith(MarketplaceRoutes.CORNERS)
        || currentPath.startsWith(MarketplaceRoutes.RECOMMENDATIONS)
    );

    return (
        <SidebarNavMenu
            open={isInMerchandisingPath}
            icon={<ArrowIcon />}
            content={<FormattedMessage id='sidebar.item.merchandising' />}
        >
            {hasMerchandisingAuthorization && (
                <SidebarItem
                    to={MarketplaceRoutes.MERCHANDISING}
                    selected={currentPath === MarketplaceRoutes.MERCHANDISING}
                >
                    <FormattedMessage id={'sidebar.item.merchandising.productList'} />
                </SidebarItem>
            )}
            {hasCategoryManagementAuthorization && (
                <SidebarItem
                    to={MarketplaceRoutes.CORNERS}
                    selected={currentPath === MarketplaceRoutes.CORNERS}
                >
                    <FormattedMessage id={'sidebar.item.corners'} />
                </SidebarItem>
            )}
            {hasOrganizationManagementAuthorization && (
                <SidebarItem
                    to={MarketplaceRoutes.RECOMMENDATIONS}
                    selected={currentPath === MarketplaceRoutes.RECOMMENDATIONS}
                >
                    <FormattedMessage id={'sidebar.item.recommendations'} />
                </SidebarItem>
            )}
        </SidebarNavMenu>
    );
}

export default MerchandisingItem;
